import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {RegistrationData} from '../models/registration-data.model';
import {RegisterDearbornUserRequest} from '../models/register-dearborn-user-request.model';
import {TermsOfUseResponse} from '../models/terms-of-use-response.model';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ValidationErrorResponse} from '../../shared/models/validation-error-response';
import {CLIENT_ID_LIST} from '../../shared/constants/dearborn-client-ids.const';
import {DomainNameParserService} from '../../shared/services/domain-name-parser.service';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  private readonly REGISTER_NEW_MEMBER_PATH = '/public/v1/dearborn/members/';
  private readonly EMAIL_VERIFICATION_PATH = '/public/v1/dearborn/users/email-link/';
  private readonly serviceLayerHost;
  private readonly clientId;

  constructor(private http: HttpClient, private domainNameParserService: DomainNameParserService) {
    this.serviceLayerHost = environment.serviceLayer.host[domainNameParserService.getState()];
    this.clientId = CLIENT_ID_LIST[this.domainNameParserService.getState()];
  }

  static convertDate(date: NgbDateStruct | null): string {
    return date ? date.year + '-' + ('0' + date.month).slice(-2) + '-' + ('0' + date.day).slice(-2) : '';
  }

  public registerUser(registrationData: RegistrationData, termsOfUseResponse: TermsOfUseResponse): Observable<ValidationErrorResponse> {
    const requestBody: RegisterDearbornUserRequest = this.createRegistrationRequest(registrationData, termsOfUseResponse);
    return this.http.post<ValidationErrorResponse>(this.getRegistrationUrl(), requestBody, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        // .set('clientId', this.clientId)
    }).pipe(
      map(_ => {
        return null;
      }),
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.status === 409 || errorResponse.status === 422) {
          return of(JSON.parse(errorResponse.error.message));
        } else {
          console.error('Server returned error response. Details: ' + JSON.stringify(errorResponse));
          return throwError('ServiceLayer returned error response.');
        }
      })
    );
  }

  public sendEmailLink(username: string): Observable<void> {
    return this.http.post(this.getResendEmailVerifictionUrl(), null, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json')
        .set('username', username),
      responseType: 'text'
    }).pipe(
      map(_ => {
        return null;
      }),
      catchError((errorResponse: HttpErrorResponse) => {
        console.error('Server returned error response. Details: ' + JSON.stringify(errorResponse));
        return throwError({status: 400, statusText: 'ServiceLayer returned error response.'});
      })
    );
  }

  private createRegistrationRequest(registrationData: RegistrationData,
                                    termsOfUseResponse: TermsOfUseResponse): RegisterDearbornUserRequest {
    return {
      corpCode: this.domainNameParserService.getState() + '1',
      username: registrationData.usernameInput,
      password: registrationData.passwordInput,
      firstName: registrationData.firstNameInput.trim(),
      lastName: registrationData.lastNameInput.trim(),
      dateOfBirth: RegistrationService.convertDate(registrationData.dobInput),
      ssn: registrationData.ssnInput,
      email: registrationData.emailInput,
      phone: registrationData.phoneNumberInput === '' ? null : registrationData.phoneNumberInput,
      termsOfUse: [
        {
          appName: "DB", // DB for all states, DN for DG
          corpCode: this.domainNameParserService.getState() + '1',
          version: termsOfUseResponse.versionId

        }
      ]
    };
  }

  private getRegistrationUrl(): string {
    // return this.serviceLayerHost + this.REGISTER_NEW_MEMBER_PATH;
    return "users";

  }

  private getResendEmailVerifictionUrl(): string {
    // return this.serviceLayerHost + this.EMAIL_VERIFICATION_PATH;
    return "resendEmailVerificationEmail";
  }
}
